export default {
  duplicate_name: '"{value}" existiert bereits. Bitte wähle einen anderen Namen.',
  // Der Name gehört einem archivierten Eintrag (docs/archiving.md), der stattdessen reaktiviert wird.
  duplicate_name_archived:
    '"{value}" gehört einem archivierten Eintrag. Reaktiviere ihn im Archiv der Übersicht, statt einen neuen anzulegen.',
  archive: {
    project_archived:
      "Das Projekt ist archiviert: Darauf entstehen keine neuen Berichte, Zeiten oder Planungen mehr. Reaktiviere es, um wieder darauf zu buchen.",
    work_time_model_archived:
      "Das Arbeitszeitmodell ist archiviert: Eine bestehende Zuordnung lässt sich nur beenden, nicht verlängern, und es kann nicht neu zugeordnet oder zum Standard gemacht werden.",
    user_archived: "Die Person ist ausgeschieden. Aktiviere sie zuerst wieder.",
    user_archive_self: "Du kannst dich nicht selbst als ausgeschieden markieren.",
    user_archive_last_administrator: "Der letzte aktive Administrator kann nicht als ausgeschieden markiert werden.",
  },
  csv: {
    empty_file: "Die CSV-Datei ist leer.",
    parse_error: "Die CSV-Datei konnte nicht gelesen werden. Bitte prüfe das Format.",
    missing_required_column: "Erforderliche Spalte(n) fehlen: {value}.",
    unknown_entity: "Für diesen Datentyp ist kein CSV-Import verfügbar.",
  },
  dataexport: {
    already_pending: "Es wird bereits ein Datenexport erstellt. Bitte warten Sie, bis er fertig ist.",
    not_available: "Dieses Archiv steht nicht (mehr) zum Download bereit.",
  },
  billing: {
    interval_unavailable: "Dieser Abrechnungszeitraum ist derzeit nicht verfügbar.",
    // {features} are the names of the refused sets, comma-separated. They go last, so no verb has to agree
    // with a plural like "Tagesmeldungen".
    addon_unavailable: "Noch nicht buchbar: {features}.",
    feature_not_entitled: "Diese Funktion ist in Ihrem Tarif nicht enthalten.",
  },
  // Abgelehnte Dateien. Beide Meldungen kommen, bevor irgendetwas gespeichert wurde.
  file: {
    // {name} statt des Content-Types: Namen kommen ohne Schrägstrich aus, und nach einem Drop von
    // zwölf Dateien ist der Name das, woran die Datei wiedererkannt wird.
    type_not_allowed: "„{name}“ hat einen Dateityp, der nicht akzeptiert wird.",
    storage_limit_reached: "Der Speicherplatz Ihres Arbeitsbereichs ist aufgebraucht.",
    // Die Grenze wird mitgeschickt statt hier wiederholt: sie steht in der Server-Konfiguration und
    // eine zweite Kopie hier würde beim nächsten Wechsel still veralten.
    too_large: "Die Datei ist zu groß. Erlaubt sind höchstens {size}.",
  },
  // Rejected by the API. The response names the offending field, but as a path into the request body
  // ("users[4].isLeading") — an internal handle, not a label anyone reading this would recognise. It
  // stays in the Sentry report; on screen the trace reference is what makes the failure findable again.
  request: {
    // The client sent something the API could not read. Not the user's doing and not theirs to fix, so
    // no "check your input" — say instead that the report has already reached us.
    malformed: "Die Änderungen konnten nicht gespeichert werden. Der Fehler wurde automatisch gemeldet.",
    // Field validation: here the user can act, but naming the field would mean naming it in the API's
    // own words, so point at the form as a whole instead.
    invalid_field: "Die Änderungen konnten nicht gespeichert werden. Bitte prüfen Sie Ihre Eingaben.",
  },
  category: {
    being_referenced_on_deletion:
      "Kategorie kann nicht gelöscht werden, da sie noch in [[hwr.datpl]] verwendet wird. Archiviere sie stattdessen.",
  },
  material: {
    being_referenced_on_deletion: "Material kann nicht gelöscht werden, da dieses bereits verwendet wird. Archiviere es stattdessen.",
  },
  purchase_price_variant: {
    label_duplicate: "Zwei Einkaufspreise tragen dieselbe Bezeichnung. Bitte eindeutig benennen.",
    limit_exceeded: "Es sind höchstens 20 Einkaufspreise je Maschine oder Material möglich.",
    report_variant_unknown:
      "Der gewählte Einkaufspreis ist im Projekt nicht mehr vorhanden. Bitte das Formular neu laden und den Preis erneut wählen.",
  },
  machine: {
    being_referenced_on_deletion: "Maschine kann nicht gelöscht werden, da diese bereits verwendet wird. Archiviere sie stattdessen.",
    hourly_wage_report_unit_unresolved:
      "Maschine hat noch keine Abrechnungseinheit. Bitte zuerst in den Stammdaten Stunde oder Tag wählen.",
    hourly_wage_report_duration_not_in_hours: "Neue oder geänderte Maschineneinsätze werden in Stunden erfasst.",
    unit_not_allowed: "Maschinen werden nur pro Stunde oder pro Tag abgerechnet.",
    selling_unit_requires_fixed_price:
      "Eine abweichende Verkaufseinheit ist nur mit Festpreis möglich. Ein Aufschlag auf den Stundenpreis ergibt keinen Tagespreis.",
  },
  hourlywagereport: {
    construction_report_required:
      "Dieses Projekt hat noch [[cr:keinen/keine/kein]] [[cr]]. Ohne einen Bericht, der die Kosten trägt, kann [[hwr:der/die/das]] [[hwr]] nicht angehängt werden. Bitte zuerst [[cr:den/die/das]] [[cr]] anlegen oder die Option abwählen.",
  },
  additionaleffort: {
    being_referenced_on_deletion:
      "Zusätzlicher Aufwand kann nicht gelöscht werden, da dieser bereits verwendet wird. Archiviere ihn stattdessen.",
  },
  user: {
    being_referenced_on_deletion: "Mitarbeiter kann nicht gelöscht werden, da dieser bereits verwendet wird.",
    already_login_user: "Dieser Mitarbeiter hat bereits einen Zugang.",
    email_already_in_use: "Diese E-Mail-Adresse wird bereits verwendet.",
  },
  userposition: {
    being_referenced_on_deletion: "Personalrolle kann nicht gelöscht werden, da diese bereits verwendet wird. Archiviere sie stattdessen.",
  },
  constructionreport: {
    project_and_date_unique: "[[cr]] Datum muss eindeutig für das Projekt sein.",
    at_least_one_user_or_machine: "[[cr]] muss mindestens ein Personal oder eine Machine haben.",
    machine_hours_outside_shift: "Die Einsatzstunden eines Geräts müssen größer als 0 sein und in die Schicht passen.",
    at_least_one_service_or_comment_or_occurrence:
      "[[cr]] muss mindestens eine Bemerkung, eine Leistung oder ein besonderes Vorkommnis haben.",
  },
  project: {
    being_referenced_on_deletion: "Projekt kann nicht gelöscht werden, da darauf bereits etwas erfasst wurde.",
  },
  // What a refused delete names as still holding the record (backend `UsageKind`), see `usedIn`.
  usage: {
    in: "Vorhanden: {list}.",
    archive_instead: "Archiviere den Eintrag stattdessen.",
    leave_instead: "Markiere die Person stattdessen als ausgeschieden.",
    PROJECT: "Projekte",
    CONSTRUCTION_REPORT: "[[cr.pl]]",
    HOURLY_WAGE_REPORT: "[[hwr.pl]]",
    HOURLY_WAGE_INVOICE: "[[hwi.pl]]",
    TIME_ENTRY: "Zeiteinträge",
    DAY_SUBMISSION: "Tagesmeldungen",
    SERVICE_PROGRESS: "Leistungsstände",
    ABSENCE: "Abwesenheiten",
    PERSONNEL_ASSIGNMENT: "Personalplanung",
    VOICE_RECORDING: "Sprachaufnahmen",
    EMPLOYEE: "Mitarbeiter",
  },
  customer: {
    being_referenced_on_deletion: "Kunde kann nicht gelöscht werden, da dieser bereits verwendet wird. Archiviere ihn stattdessen.",
    contact: {
      position: {
        being_referenced_on_deletion:
          "Kunden Ansprechpartner Position kann nicht gelöscht werden, da diese bereits verwendet wird.",
      },
      delete_has_reference:
        'Kunden Ansprechpartner "{value}" kann nicht gelöscht werden, da eine referenz von diesem verwendet wird.',
    },
  },
  hourlywageinvoice: {
    missing_selling_price_for_user_position: 'Verkaufspreis für Mitarbeiterrolle "{value}" ist nicht gesetzt.',
    missing_user_position_in_project: 'Mitarbeiterposition "{value}" existiert nicht im Projekt.',
    missing_price_for_additional_effort:
      'Realpreis muss gesetzt sein für Zusätzliche Leistung "{value}", damit der Variable Preis berechnet werden kann.',
    missing_purchase_price_for_material:
      'Einkaufspreis muss gesetzt sein für Material "{value}", damit der Variable Preis berechnet werden kann.',
    missing_purchase_price_for_machine:
      'Einkaufspreis muss gesetzt sein für Maschine "{value}", damit der Variable Preis berechnet werden kann.',
    // Die Zeile im Projekt hat gar keinen Verkaufspreis: ein leerer Festpreis oder ein Aufschlag ohne Prozentsatz.
    missing_selling_price_for_material: 'Material "{value}" hat in diesem Projekt keinen Verkaufspreis.',
    missing_selling_price_for_machine: 'Maschine "{value}" hat in diesem Projekt keinen Verkaufspreis.',
    missing_selling_price_for_additional_effort:
      'Zusätzliche Leistung "{value}" hat in diesem Projekt keinen Verkaufspreis.',
    selling_price_already_set:
      "Im Projekt wurde inzwischen ein Verkaufspreis gesetzt. Ihre Eingabe wurde nicht übernommen.",
    custom_number_too_long: "Die eigene Abrechnungsnummer darf höchstens {max} Zeichen lang sein.",
  },
  settings: {
    role: {
      edit_administrator: "Administrator Rolle kann nicht bearbeitet werden.",
      delete_administrator: "Administrator Rolle kann nicht gelöscht werden.",
      delete_used_reference: "Rolle kann nicht gelöscht werden, solange diese Personal zugewiesen wurde.",
      administrator_only_permission: "Diese Rechte hat nur die Rolle Administrator.",
      missing_permission_dependency: "Einige dieser Rechte setzen weitere Rechte voraus, die der Rolle fehlen.",
    },
    logo: {
      unsupported_type: "Das Firmenlogo muss ein PNG- oder JPEG-Bild sein.",
      too_large: "Das Firmenlogo darf nicht größer als 2 MB sein.",
    },
  },
  // PDF-Vorlagen: Briefpapiere und Vorlagen.
  pdf: {
    letterhead_name_taken: "Ein Briefpapier mit diesem Namen gibt es schon.",
    template_name_taken: "Für dieses Dokument gibt es schon eine Vorlage mit diesem Namen.",
    template_not_found: "Die gewählte Vorlage gibt es nicht mehr.",
    type_mismatch: "Die Vorlage gehört zu einem anderen Dokument.",
    letterhead_in_use: "Das Briefpapier wird noch verwendet von: {templates}.",
    image_in_use: "Das Bild steht noch auf dem Briefpapier. Entfernen Sie zuerst den Block.",
    image_limit: "Ein Briefpapier hat höchstens {limit} Bilder.",
    image_type: "Ein Bild muss PNG oder JPEG sein.",
    image_too_large: "Ein Bild darf nicht größer als 2 MB sein.",
    image_too_many_pixels: "Ein Bild darf höchstens {megapixels} Megapixel und {side} Pixel je Seite haben.",
    system_read_only: "Mitgelieferte Briefpapiere und Vorlagen lassen sich nur kopieren.",
    invalid: {
      BODY_TOO_SMALL: "Der Inhaltsbereich ist zu klein. Er braucht mindestens 141 × 106 mm.",
      OFF_PAGE: "Ein Block liegt außerhalb der Seite.",
      DUPLICATE_ID: "Zwei Blöcke haben dieselbe Kennung.",
      UNKNOWN_PLACEHOLDER: "Unbekanntes Feld im Text: {detail}",
      PAGE_TOTAL_MISPLACED: "Die Gesamtseitenzahl steht nur am Ende einer Seitenzahl.",
      IMAGE_MISSING: "Einem Bild fehlt die Bilddatei.",
      LETTERHEAD_NOT_FOUND: "Das gewählte Briefpapier gibt es nicht mehr.",
      TOO_MANY_LABELS: "Höchstens drei Unterschriften.",
      LABEL_TOO_LONG: "Eine Unterschrift ist zu lang.",
      NULL_ELEMENT: "Die Gestaltung ist unvollständig. Bitte laden Sie die Seite neu.",
      other: "Diese Gestaltung lässt sich nicht drucken.",
    },
  },
  // Tagesmeldungen: die Codes, die einen Eintrag betreffen, stehen auch neben dem Eintrag.
  daysubmission: {
    date_invalid: "Der Tag liegt außerhalb der Tage, für die ein Bericht möglich ist.",
    too_large: "Die Tagesmeldung hat mehr Einträge, als ein Tag haben kann.",
    comment_invalid: "Der Kommentar ist leer oder zu lang.",
    comment_limit: "Die Tagesmeldung hat schon so viele Kommentare, wie sie aufnehmen kann.",
    not_open:
      "Die Tagesmeldung ist nicht mehr offen: Sie wurde übernommen, wird gerade übernommen oder wurde verworfen.",
    changed: "Mit der Tagesmeldung ist inzwischen etwas geschehen. Bitte laden Sie sie neu.",
    report_busy:
      "Gerade wird ein anderer Bericht dieser Baustelle und dieses Tages gespeichert. Versuchen Sie es gleich noch einmal.",
    entry_invalid: "Das passt nicht mehr zur Tagesmeldung. Öffnen Sie den Bericht aus der Tagesmeldung neu.",
    project_missing: "Wählen Sie eine Baustelle für den Bericht.",
    report_changed:
      "[[Cr:Der/Die/Das]] [[cr]] des Tages wurde inzwischen geändert. Öffnen Sie den Bericht aus der Tagesmeldung neu.",
  },
  timetracking: {
    model_not_found: "Das gewählte Arbeitszeitmodell gibt es nicht mehr. Bitte ein anderes wählen.",
    model_being_referenced_on_deletion:
      "Arbeitszeitmodell kann nicht gelöscht werden, da damit bereits Zeiten erfasst wurden oder Mitarbeiter es nutzen.",
    model_name_already_exists: "Ein Arbeitszeitmodell mit diesem Namen gibt es bereits.",
    model_name_archived: "Ein archiviertes Arbeitszeitmodell trägt diesen Namen. Reaktiviere es im Archiv, statt ein neues anzulegen.",
    assignment_invalid: "Die Zuweisungen überschneiden sich oder enden vor ihrem Beginn. Bitte die Zeiträume prüfen.",
    entry_not_found: "Eine der ausgewählten Zeiten gibt es nicht mehr. Bitte die Ansicht neu laden.",
    // Der Code TIME_ENTRY_INVALID_TIME_RANGE deckt drei Fälle ab: Beginn gleich Ende, ein Tag
    // ohne Ende und die Freigabe eines noch laufenden Tages. Der Wortlaut muss auf alle drei
    // passen — "Das Ende muss nach dem Beginn liegen" traf nur den ersten.
    invalid_time_range: "Beginn und Ende ergeben keine Arbeitszeit.",
    break_outside_shift: "Eine Pause liegt außerhalb der erfassten Arbeitszeit.",
    breaks_overlap: "Zwei Pausen überschneiden sich.",
    overlaps_existing: "Für diesen Mitarbeiter ist an diesem Tag bereits eine überschneidende Zeit erfasst.",
    exceeds_daily_maximum: "Die Arbeitszeit überschreitet die im Arbeitszeitmodell zulässige Höchstarbeitszeit.",
    already_running: "Es läuft bereits eine Zeiterfassung. Bitte zuerst beenden.",
    not_running: "Es läuft derzeit keine Zeiterfassung.",
    // Beide Fälle entstehen fast immer dadurch, dass am Telefon schon gestempelt wurde. Der Satz
    // nennt deshalb den Zustand des Tages und nicht den Fehler.
    break_already_running: "Es läuft bereits eine Pause.",
    break_not_running: "Für diesen Tag läuft gerade keine Pause.",
    already_approved: "Die Zeit ist bereits freigegeben und muss zuerst wieder geöffnet werden.",
    employee_not_found: "Der Mitarbeiter wurde nicht gefunden.",
    absence_not_found: "Diese Art der Abwesenheit gibt es nicht mehr. Bitte eine andere wählen.",
    absence_overlaps:
      "Die Abwesenheit passt an manchen Tagen nicht neben die vorhandene. Bitte erneut eintragen und wählen, was mit diesen Tagen geschieht.",
    // Nicht "abgelehnt": es liegt nicht am Eintrag, sondern am abgeschlossenen Monat — und wer
    // Zeiten freigeben darf, kann ihn wieder öffnen.
    project_not_bookable: "Auf dieses Projekt dürfen Sie keine Zeit buchen. Bitte ein anderes oder keines wählen.",
    // Sagt, wer es stattdessen tut, statt nur "nicht erlaubt": die Freigabe ist nicht gesperrt, sie
    // gehört nur jemand anderem.
    self_review: "Selbst erfasste Zeiten kann nur eine andere Person freigeben, ablehnen oder wieder öffnen.",
    location_invalid: "Der übermittelte Standort ist ungültig.",
  },
  personnelplanning: {
    date_exceeds_project_span: "Start- und Enddatum müssen innerhalb des Projekt-/Phasenzeitraums liegen.",
    not_found: "Kalendar konnte nicht gefunden werden.",
    name_already_exists: "Name existiert bereits.",
    assignment_invalid_date_range: "Start- oder Enddatum der Zuweisung ist fehlerhaft.",
    assignment_date_outside_project_range: "Start- und Enddatum müssen innerhalb des Projektzeitraums liegen.",
    assignment_date_outside_phase_range: "Start- und Enddatum müssen innerhalb des Phasenzeitraums liegen.",
    referenced_project_not_found: "Projekt konnte nicht gefunden werden.",
    referenced_employee_not_found: "Mitarbeiter konnte nicht gefunden werden.",
    referenced_team_not_found: "Trupp konnte nicht gefunden werden.",
    referenced_phase_not_found: "Phase konnte nicht gefunden werden.",
    assignment_project_not_in_list: "Projekt muss dem Kalendar erstmal zugewiesen werden.",
    assignment_employee_not_in_list: "Mitarbeiter muss dem Kalendar erstmal zugewiesen werden.",
    assignment_phase_not_found: "Phase konnte nicht gefunden werden.",
    includes_all_projects:
      "Dieser Kalender zeigt alle Projekte. Projekte lassen sich hier weder hinzufügen noch entfernen.",
    employee_on_project:
      "Diese Person ist auf einem der Projekte eingeplant und steht deshalb immer im Kalender „Alle Projekte“.",
    built_in: "Der Kalender „Alle Projekte“ ist fest eingebaut und lässt sich weder löschen, umbenennen noch anpinnen.",
  },
  serviceCatalog: {
    position_identifier_not_unique: "Diese Pos-Nr. ist im Leistungskatalog bereits vergeben.",
    position_booked: "Die Position ist in [[cr.datpl]] gebucht und kann nicht gelöscht oder zum Titel gemacht werden.",
    title_not_empty: "Unter diesem Titel stehen noch Einträge.",
    invalid_parent: "Dorthin kann der Eintrag nicht verschoben werden.",
    change_order_number_not_unique: "Diese Nachtragsnummer ist bereits vergeben.",
    change_order_has_positions: "Dem Nachtrag sind noch Positionen zugeordnet.",
    entry_position_mismatch: "Eine gebuchte Position gehört nicht zu diesem Projekt.",
    entry_not_bookable: "Wahlpositionen und Positionen abgelehnter Nachträge können nicht gebucht werden.",
    entry_duplicate: "Eine Position ist mehrfach gebucht. Bitte einmal mit der Tagesmenge buchen.",
    cost_split_invalid: "Die Kostenanteile müssen zusammen 100 % ergeben.",
    position_has_progress:
      "Für die Position sind Leistungsstände erfasst. Löschen Sie diese zuerst im Verlauf der Position.",
    progress_date_in_future: "Ein Leistungsstand kann nicht in der Zukunft liegen.",
    progress_not_recordable:
      "Für Wahlpositionen und Positionen abgelehnter Nachträge kann kein Leistungsstand erfasst werden.",
    progress_position_mismatch: "Eine Position gehört nicht zu diesem Projekt.",
    progress_date_taken: "Für diesen Tag ist bei der Position schon ein Leistungsstand erfasst.",
    gaeb_unsupported: "Die Datei ist kein unterstütztes GAEB-DA-XML (X83, X84 oder X86).",
  },
  pin: {
    type_not_supported: "Dieser Eintrag lässt sich nicht anpinnen.",
    limit_reached: "In dieser Liste können Sie höchstens {max} Einträge anpinnen. Lösen Sie zuerst einen anderen.",
  },
}
